import { Box, Button, ButtonGroup, Grid, GridItem, Stack, Text } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import { Form, Parts, UI } from "components";
import { API } from "config";
import { toaster } from "config";
import { useState } from "react";
import { useNavigate } from "react-router";

export default function Identity(){

    const queryClient = useQueryClient()
    const navigate = useNavigate()

    const [ type, setType ] = useState('rg')
    const [ front, setFront ] = useState(null)
    const [ back, setBack ] = useState(null)
    const [ selfie, setSelfie ] = useState(null)
    const [ loading, setLoading ] = useState(false)

    const frontPalette = !front ? 'red' : 'green'
    const frontIcon = !front ? 'alert' : 'check'
    const backPalette = !back ? 'red' : 'green'
    const backIcon = !back ? 'alert' : 'check'
    const selfiePalette = !selfie ? 'red' : 'green'
    const selfieIcon = !selfie ? 'alert' : 'check'

    const handleSubmit = async () => {
        if(!type || !front || !back || !selfie) return
        setLoading(true)

        try{
            const form = new FormData()
            form.append('front_file', front)
            form.append('back_file', back)
            form.append('selfie_file', selfie)
            form.append('type', type)
            await API.post('/me/identity', form, { headers: { "Content-Type": "multipart/form-data" } })
            toaster.create({ title: 'Seus documentos foram enviados para análise. Obrigado!', type: 'success' });
            queryClient.invalidateQueries('user')
            navigate('/')
        }catch(err){
            toaster.create({ title: 'Não foi possível enviar um ou mais documentos. Tente novamente.', description: err?.response?.data?.message, type: 'warning' })
            setLoading(false)
        }
    }

    return(
    <>
    <UI.Header hiddenAlerts title="Confirme sua identidade" />

    <Form.Container mt={4} onSubmit={handleSubmit}>

        <Form.Options
            required
            label="Tipo de documento:"
            options={[{ label: 'RG', value: 'rg', description: 'Registro Geral' }, { label: 'CNH', value: 'cnh', description: 'Carteira Nacional de Habilitação' }, { label: 'Internacional', value: 'international' }]}
            helper="Selecione o tipo de documento que deseja enviar."
            value={type}
            onChange={setType}
        />

        <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(3, 1fr)', lg: 'repeat(3, 1fr)' }} gap={4}>

            <GridItem>
                <Stack p={6} background={frontPalette + '.muted'} borderRadius={4} gap={4}> 
                    <Text color={frontPalette + '.fg'}><UI.Icon name={frontIcon} /> Frente do documento:</Text>
                    <Text fontSize="sm">Por favor, envie ou tire uma foto da parte da frente do documento.</Text>

                    <Stack textAlign="center" gap={1}>
                        <Form.Upload.Button required placeholder="Enviar frente" value={front} onChange={e => setFront(e.target.files[0])} accept="image/*" />
                        <Text fontSize="xs"color="GrayText">* São aceitos apenas arquivos de imagem (jpg ou png) com até 5MB.</Text>
                    </Stack>
                </Stack>
            </GridItem>

            <GridItem>
                <Stack p={6} background={backPalette + '.muted'} borderRadius={4} gap={4}> 
                    <Text color={backPalette + '.fg'}><UI.Icon name={backIcon} /> Verso do documento:</Text>
                    <Text fontSize="sm">Por favor, envie ou tire uma foto da parte de trás do documento.</Text>

                    <Stack textAlign="center" gap={1}>
                        <Form.Upload.Button required placeholder="Enviar verso" value={back} onChange={e => setBack(e.target.files[0])} accept="image/*" />
                        <Text fontSize="xs"color="GrayText">* São aceitos apenas arquivos de imagem (jpg ou png) com até 5MB.</Text>
                    </Stack>
                </Stack>
            </GridItem>

            <GridItem>
                <Stack p={6} background={selfiePalette + '.muted'} borderRadius={4} gap={4}> 
                    <Text color={selfiePalette + '.fg'}><UI.Icon name={selfieIcon} /> Selfie:</Text>
                    <Text fontSize="sm">Agora precisamos que tire uma selfie segurando o seu documento.</Text>

                    <Stack textAlign="center" gap={1}>
                        <Form.Upload.Button required placeholder="Enviar selfie" value={selfie} onChange={e => setSelfie(e.target.files[0])} accept="image/*" />
                        <Text fontSize="xs"color="GrayText">* São aceitos apenas arquivos de imagem (jpg ou png) com até 5MB.</Text>
                    </Stack>
                </Stack>
            </GridItem>

        </Grid>

        <Button type="submit" size="lg" disabled={!front || !back || !selfie} loading={loading} loadingText="Enviando documentos..." colorPalette="orange">Enviar documentos <UI.Icon name="next" /></Button>

    </Form.Container>
    </>
    )
}